<template>
    <div class="bottomCont">
        <footer class="footer">
            <div class="footer-collapse">
                <div class="bottom-nav" v-if="title && title !== 'Home'">
                    <div class="nav-logo">
                        <img src="@/assets/logo.png" alt="">
                    </div>
                    <div class="to">
                        <img src="@/assets/to.png" alt="">
                    </div>
                    <div class="nav-title">{{ title }}</div>
                </div>
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item :title="$t('footer.localWebsites.title')" name="1">
                        <div v-for="(item, index) in $t('footer.localWebsites.list')" :key="index">
                            <!-- <a :href="item.toLink">{{ item.title }}</a> -->
                            {{ item.title }}
                        </div>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('footer.info.title')" name="2">
                        <div v-for="(item, index) in $t('footer.info.list')" :key="index">
                            <!-- <a :href="item.toLink">{{ item.title }}</a> -->
                            {{ item.title }}
                        </div>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('footer.contact.title')" name="3">
                        <div>
                            <p>{{ information?.mobile || $t('footer.contact.contactInfomation') }}</p>
                            <p>{{information?.address || $t('footer.contact.name') }}</p>
                            <p>{{ information?.email ||$t('footer.contact.e-mail') }}</p>
                        </div>
                        <div class="contact-info-other-icon">
                            <div class="contact-info-other-icon-div">
                                <img src="../assets/bottom-f.png" alt="">
                                </img>
                                <a :href="information?.facebook"></a>
                            </div>
                            <div class="contact-info-other-icon-div">
                                <img src="../assets/bottom-in.png" alt=""></img>
                                <a :href="information?.linkedIn"></a>
                            </div>
                            <div class="contact-info-other-icon-div">
                                <img src="../assets/bottom-p.png" alt=""></img>
                                <a :href="information?.twitter"></a>
                            </div>
                            <div class="contact-info-other-icon-div contact-info-other-icon-div-last">
                                <img src="../assets/bottom-x.png" alt=""></img>
                                <a :href="information?.instagram"></a>
                            </div>
                            <div class="contact-info-other-icon-line"></div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div class="footer-copyright">
                    {{ $t('footer.contact.copyright') }}
                </div>
            </div>

        </footer>
    </div>
</template>
<script>
import {getConfigInformation} from '@/api/komo.js';
export default {
    name: 'bottomContMobile',
    components: {
    },
    props: {
        title: '',
    },
    data() {
        return {
            activeNames: [],
            information:{}
        }
    },
    created() {
        getConfigInformation().then(res => {
            this.information = res?.data;
        })
    },
    methods: {
        handleChange(value) {
            console.log(value);
        }
    },
}
</script>
<style scoped>
.bottomCont {
    width: 100%;
    height: 100%;
    color: #fff;
    /* position: relative; */
}

.footer {
    background-image: url(../assets/homeMb/bottom-bg-mobile.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 0;
    padding: 100px 0 30px;
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
}

.footer-collapse {
    width: 100%;
    /* height: 200px; */
    padding: 20px 20px;
}

.footer-collapse {
    --el-collapse-header-bg-color: transparent;
    --el-collapse-content-bg-color: transparent;
    --el-collapse-border-color: transparent;
}

/* 穿透修改elementui中 collapse的样式*/
.footer-collapse :deep(.el-collapse-item__header),
.footer-collapse :deep(.el-collapse-item__wrap),
.footer-collapse :deep(.el-collapse-item__content) {
    background-color: transparent !important;
}

.footer-collapse :deep(.el-collapse) {
    border-top: 1px solid #c3c8b9;
    border-bottom: 1px solid #c3c8b9;
}

.footer-collapse :deep(.el-collapse-item__header) {
    border-bottom: 1px solid #c3c8b9;
    /* border-bottom: none; */
}

.footer-collapse :deep(.el-collapse-item__wrap) {
    border-bottom: 1px solid #c3c8b9;
    /* border-bottom: none; */
}


.contact-info-other-icon {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 10px 0 20px 0;
	gap: 2%;
}
.contact-info-other-icon-div{
	width: 8%;
	height: 100%;
	position: relative;
}
.contact-info-other-icon-div-last{
	margin-right: 10%;
}

.contact-info-other-icon img {
	width:100%;
	height:100%;
}
.contact-info-other-icon a{
	width: 100%;
	height: 100%;
	position: absolute;
	top:0;
	left: 0;
	z-index: 10;
}

.contact-info-other-icon-line {
    width: 15%;
    height: 1px;
    border: 1px solid #1E1E1E;
}

.footer-copyright {
    line-height: 60px;
    text-align: center;
    font-size: 3vw;
    color: #666666;
}

.bottom-nav {
    width: 100%;
    display: flex;
    align-items: center;
}

.nav-logo {
    width: 15vw;

}

.nav-logo img {
    width: 100%;
}

.to {
    width: 3vw;
    margin: 0 1.5vw;
}

.to img {
    width: 100%;
}

.nav-title {
    font-size: 3.5vw;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 400;
    color: #000000;
}
</style>